import React, { type PropsWithChildren, type CSSProperties } from 'react'

import './AspectContainer.scss'

interface AspectContainerProps {
  ratio?: number
  style?: CSSProperties
}

const AspectContainer = ({
  ratio = 16 / 9,
  style = {},
  children,
}: PropsWithChildren<AspectContainerProps>) => {
  const newStyle = { '--aspect-ratio': ratio, ...style } as CSSProperties
  return (
    <div className="aspect-container" style={newStyle}>
      <div className="aspect-container-children-enclosure">{children}</div>
    </div>
  )
}

export default AspectContainer
